import { object, SchemaOf, string } from 'yup';


export type Fields = {
  customerID: string;
};


export const validationSchema: SchemaOf<Fields> = object().shape({
  customerID: string().required(),
});

